import { render, staticRenderFns } from "./EducationProtocolForm.vue?vue&type=template&id=713b23e7&"
import script from "./EducationProtocolForm.vue?vue&type=script&lang=ts&"
export * from "./EducationProtocolForm.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports